import { Checkbox } from '@talentmesh/ui/components/checkbox';
import { Label } from '@talentmesh/ui/components/label';
import { Controller, useFormContext } from 'react-hook-form';
import InviteCandidateTooltipBody from './InviteCandidateTooltipBody';
import UIStrings from '@/Utils/UIStrings';

function CheckboxWithTooltip() {
    const { control } = useFormContext();

    return (
        <div className="flex flex-row items-center gap-2">
            <Controller
                name="isInternal"
                control={control}
                render={({ field }) => (
                    <div className="flex items-center gap-2">
                        <Checkbox
                            id="isInternal"
                            checked={Boolean(field.value)}
                            onCheckedChange={(v) => field.onChange(v === true)}
                            data-cy="isInternal"
                        />
                        <Label htmlFor="isInternal" className="cursor-pointer font-normal">
                            {UIStrings.UseAsInternalBenchmark}
                        </Label>
                    </div>
                )}
            />
            <InviteCandidateTooltipBody />
        </div>
    );
}

export default CheckboxWithTooltip;
